export default {module:'Card/List',view:'Element/List',options:{events:{onClick:'detail'},limit:5,md:12}}